import { proNavigator } from "single-spa/react-app/ProNavigator";

import { AFTER_TRIAL_MODAL_ROOT_AUTOMATION } from "./constants";

export const SI_AFTER_TRIAL_HOME_STATE = "salesIntelligence-home";

export const isAfterTrialEntryModalInDom = (): boolean => {
    const modalRoot = document.querySelector(`[data-automation="${AFTER_TRIAL_MODAL_ROOT_AUTOMATION}"]`);

    return modalRoot != null && document.body.contains(modalRoot);
};

export const shouldReloadAfterTrialModalRemoved = (wasModalInDom: boolean, isModalInDom: boolean): boolean =>
    wasModalInDom && !isModalInDom;

export const buildSiAfterTrialHomeLocation = (
    href: string,
    origin: string,
    pathname: string,
): string => {
    if (href.startsWith("http://") || href.startsWith("https://")) {
        return href;
    }

    const hashPart = href.startsWith("#") ? href : href.startsWith("/") ? `#${href}` : `#/${href}`;

    return `${origin}${pathname}${hashPart}`;
};

const normalizeLocation = (url: string): string => {
    try {
        return new URL(url).href;
    } catch {
        return url;
    }
};

/**
 * Pro uses hash routing: assign/href alone does not remount the app, so the banner stays missing.
 * Point the document at SI home, then reload so AfterTrialEntryModal mounts again.
 */
export const reloadToSiAfterTrialHome = (): void => {
    const homeLocation = buildSiAfterTrialHomeLocation(
        proNavigator.href(SI_AFTER_TRIAL_HOME_STATE),
        window.location.origin,
        window.location.pathname,
    );

    const isOnHome = normalizeLocation(window.location.href) === normalizeLocation(homeLocation);

    if (!isOnHome) {
        window.location.replace(homeLocation);
    }

    window.location.reload();
};
